module.exports = __webpack_public_path__ + "assets/img/one-tab4-on.b68466ca.png";